import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://api-eventos-legado.uzerpass.com.br/api',
  //baseURL: 'https://hml-api-eventos-legado.uzerpass.com.br/api',
  ////baseURL: 'http://localhost/BUzer.Acesso/api',
  ////baseURL: 'https://luxsolucoes.com.br/BUzer-Acesso/api',
  //baseURL: 'http://localhost:5243/api'
});

// Antes, o header authorization só era setado uma vez, na hora do login
// (requisicaoApiV2.defaults.headers.common['authorization'] = ...), e se perdia a
// cada F5 (só existia em memória). Com o interceptor, o token é relido do
// localStorage a cada requisição, igual ao padrão já usado em ApiAdmin.js/ApiNotification.js.
instance.interceptors.request.use((config) => {
  const tokenSalvo = localStorage.getItem('token');
  if (tokenSalvo) {
    let token = tokenSalvo;
    try {
      token = JSON.parse(tokenSalvo);
    } catch (err) {
      token = tokenSalvo;
    }
    config.headers['authorization'] = 'Bearer ' + token;
  }
  return config;
});

export default instance;